import { useMutation, useQueryClient } from '@tanstack/react-query';
import { deleteUserSignature } from '@dealstack/frontend/shared/dataExchange/services/god.service';
import { SAVED_SIGNATURE_QUERY_KEY } from './useSavedSignature';

export const useDeleteUserSignature = () => {
	const queryClient = useQueryClient();
	return useMutation({
		mutationFn: () => deleteUserSignature(),
		onSuccess: () => queryClient.invalidateQueries({ queryKey: SAVED_SIGNATURE_QUERY_KEY }),
	});
};
